const app = angular.module('msi.payments.expirationWarningController', []);

class expirationWarningController {
  constructor(paymentService, $translate) {
    this.paymentService = paymentService;
    this.billingConfig = paymentService.getPaymentConfig();
    this.$translate = $translate;
  }

  $onInit() {
    this.setExpirationBannerAvailability();
  }

  setExpirationBannerAvailability() {
    this.$translate('PAYMENT_EXPIRATION_WARNING_BANNER')
      .then((foundKey) => {
        if (foundKey !== '') {
          this.paymentExpirationWarning = true;
        }
      });
  }

  $postLink() {
    this.paymentService.getPayment(this.shipment.paymentId).then((payment) => {
      this.showWarning = payment.ccExpDate.willBeExpiredOn(this.shipment.place);
    });
  }
}

expirationWarningController.$inject = ['paymentService', '$translate'];

app.controller('expirationWarningController', expirationWarningController);

module.exports = app.name;
